/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Resend_Verification_ButtonInputs */



/**
* | output |
* | --- |
* | "Resend Verification Email" |
*
* @param {Login_Resend_Verification_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_resend_verification_button = /** @type {((inputs?: Login_Resend_Verification_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Resend_Verification_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Renvoyer l'Email de Vérification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigungs-E-Mail erneut senden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia nuovamente l'email di verifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повторная отправка письма с подтверждением.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reenviar correo electrónico de verificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重新发送验证邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("確認メールを再送信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्यापन ईमेल पुनः भेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reenviar e-mail de verificação")
	return /** @type {LocalizedString} */ ("Resend Verification Email")
});